import React from 'react';
import { FdrRecommendationListSkeleton } from 'fdr/components/local/fdr-recommendation-list/fdr-recommendation-list.skeleton';

export const fdrPageComponentsPlaceholder = Array.from(
  { length: 3 },
  (__, i) => <FdrRecommendationListSkeleton hasTitle={true} key={i} />
);
